import { jsx as _jsx } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import 'react';
import classNames from 'classnames';
const SelectFilter = (props) => {
    const { isFilterActive, filterValue, onChange } = props;
    const inputClasses = classNames('select-filter-input', (isFilterActive || filterValue) && 'select-filter-input-active');
    // biome-ignore lint/a11y/noAutofocus: autofocus is intentionally set to allow instant typing to filter
    return _jsx("input", { type: 'text', className: inputClasses, autoFocus: true, onChange: onChange, value: filterValue });
};
export default SelectFilter;
